import { useState } from 'react';
import { useAppSelector } from '../../../../../hooks/reduxHooks';
import { useTranslation } from 'react-i18next';
import useTranslate from '../../../../../hooks/useTranslate';
import useGlobalFilters from '../../../../../hooks/useGlobalFilters';
import useTableMenu from '../../../../../hooks/useTableMenu';
import { useGetCarcinogenicReportWorkersQuery } from '../../../../../services/carcinogenicApi';
import { CarcinogenicReportWorker, CarcinogenicReportWorkerRisk } from '../types';
import { WORKERS_DRAWER_ACTION_VALUES } from '../components/drawers';
import { useDispatch } from 'react-redux';

const useWorkersAndMedicalExaminationsModule = () => {
    const selectedCarcinogenicReportId = useAppSelector(
        (state) => state?.carcinogenicReport?.selectedCarcinogenicReportId
    );
    const [selected, setSelected] = useState<null | CarcinogenicReportWorker>(null);
    const [open, setOpen] = useState<string>('');
    const { t } = useTranslation('carcinogenicReport', {
        keyPrefix: 'modules.workersAndMedicalExams'
    });
    const { translate } = useTranslate(t);
    const workersAndMedicalExaminationsFilters = useGlobalFilters();
    const workersAndMedicalExaminationsTableMenu = useTableMenu();

    const { filters } = workersAndMedicalExaminationsFilters;

    const { data: workers, isFetching: isFetchingWorkers } = useGetCarcinogenicReportWorkersQuery({
        reportId: selectedCarcinogenicReportId,
        filters: filters
    });

    const handleClickEditWorkerIcon = (worker: CarcinogenicReportWorker) => {
        setSelected(worker);
        setOpen(WORKERS_DRAWER_ACTION_VALUES.EDIT_WORKER);
    };

    const isExposed = (worker: CarcinogenicReportWorker): boolean => {
        return worker?.puestoTrabajo?.riesgos?.some(
            (risk: CarcinogenicReportWorkerRisk) => risk.cancerigeno === true
        );
    };

    return {
        translate,
        handleClickEditWorkerIcon,
        isExposed,
        setOpen,
        workers,
        workersAndMedicalExaminationsFilters,
        workersAndMedicalExaminationsTableMenu,
        selected,
        isFetchingWorkers,
        open
    };
};

export default useWorkersAndMedicalExaminationsModule;
